export function goFullScreen(containerName) {
    let elem = document.getElementById(containerName);
    if (elem) {
        if (!!elem.requestFullscreen) {
            return elem.requestFullscreen();
        } else if (!!elem.msRequestFullscreen) {
            return elem.msRequestFullscreen();
        } else if (!!elem.mozRequestFullScreen) {
            return elem.mozRequestFullScreen();
        } else if (!!elem.webkitRequestFullscreen) {
            return elem.webkitRequestFullscreen();
        }
    }
}

export function exitFullScreen() {
    if (!!document.exitFullscreen) {
        document.exitFullscreen();
    } else if (!!document.msExitFullscreen) {
        document.msExitFullscreen();
    } else if (!!document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
    } else if (!!document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
    }
}

export function addFullScreenListeners(fullScreenHandler) {
    document.addEventListener('fullscreenchange', fullScreenHandler);
    document.addEventListener('webkitfullscreenchange', fullScreenHandler);
    document.addEventListener('mozfullscreenchange', fullScreenHandler);
    document.addEventListener('MSFullscreenChange', fullScreenHandler);
}

export function removeFullScreenListeners(fullScreenHandler) {
    document.removeEventListener('fullscreenchange', fullScreenHandler);
    document.removeEventListener('webkitfullscreenchange', fullScreenHandler);
    document.removeEventListener('mozfullscreenchange', fullScreenHandler);
    document.removeEventListener('MSFullscreenChange', fullScreenHandler);
}

export function browserHasFullScreenCapabilities() {
    return !!document.fullscreenEnabled || !!document.mozFullScreenEnabled || !!document.webkitFullscreenEnabled || !!document.msFullscreenEnabled;
}

export function hasVirtualKeyboard(store) {
    return (store.getState().vpp.hasTouchScreen || store.getState().vpp.showVirtualKeyboard);
}


// WEBPACK FOOTER //
// ./src/helpers/layoutHelpers.js